export default __webpack_public_path__ + "static/cnn_bg-665f6f3fcd47a334b6828710e506100e.png";